import {
  QueryFunction,
  useQuery as rqUseQuery,
  UseQueryOptions as RQUseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'

import { useTribeClient } from '../../useTribeClient.js'

import type { QueryKey } from './QueryKey.js'

export type UseQueryOptions<
  TQueryFnData = unknown,
  TError = unknown,
  TData = TQueryFnData,
  TQueryKey extends QueryKey = QueryKey,
> = RQUseQueryOptions<TQueryFnData, TError, TData, TQueryKey>

type TUseQuery = <
  TQueryFnData = unknown,
  TError = unknown,
  TData = TQueryFnData,
  TQueryKey extends QueryKey = QueryKey,
>(
  queryKey: TQueryKey,
  queryFn: QueryFunction<TQueryFnData, TQueryKey>,
  options?: UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>,
) => UseQueryResult<TData, TError>

export const useQuery: TUseQuery = (key, fetchFn, options) => {
  const { ready } = useTribeClient()
  return rqUseQuery(key, fetchFn, {
    enabled: !ready ? false : options?.enabled,
    ...options,
  })
}
